import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const [timer, setTimer] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  const startTimer = (seconds, callback) => {
    setTimer(seconds);
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          callback();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleGenerateLink = () => {
    setStep(1);
    startTimer(10, () => {
      setShowButton(true);
    });
  };

  const handleScrollButton = () => {
    setStep(2);
    setShowButton(false);
    
    const bottomSection = document.getElementById('bottom-section');
    if (bottomSection) {
      bottomSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    setTimeout(() => {
      setShowButton(true);
    }, 1500);
  };

  const handleSecondButton = () => {
    setStep(3);
    setShowButton(false);
    startTimer(10, () => {
      setShowButton(true);
    });
  };

  const handleGetLink = () => {
    navigate('/verification');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-blue-600 text-white py-6 shadow-md">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold">Financial Hub</h1>
          {/* <p className="text-blue-100">Your Gateway to Financial Freedom</p> */}
        </div>
      </header>

      {/* Main Content Container */}
      <div className="container mx-auto px-4 py-8">

        {/* STEP 1 - Top Section */}
        <section className="mb-6 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg p-5 text-white shadow-lg">
  <div className="max-w-lg mx-auto text-center">
    <h2 className="text-xl font-semibold mb-2">Join Our Telegram Channel</h2>
    <p className="mb-4 text-blue-100 text-sm">
      Get your exclusive link by joining our telegram channel
    </p>

    {step === 0 && (
      <button
        onClick={handleGenerateLink}
        className="bg-white text-blue-600 font-semibold py-2 px-5 rounded-md hover:bg-gray-100 transition duration-300 shadow"
      >
        Generate Link
      </button>
    )}

    {step >= 1 && (
      <div className="bg-white/20 backdrop-blur-sm rounded-md p-3 mb-3">
        <div className="inline-block bg-green-500 text-white px-4 py-1 rounded-full mb-2 text-sm font-medium">
          ✓ Step 1/4 Complete
        </div>
      </div>
    )}

    {timer !== null && timer > 0 && step === 1 && (
      <div className="bg-white/20 backdrop-blur-sm rounded-md p-4">
        <div className="text-4xl font-bold mb-1">{timer}</div>
        <p className="text-blue-100 text-sm">Please wait...</p>
      </div>
    )}

    {step === 1 && showButton && (
      <button
        onClick={handleScrollButton}
        className="bg-yellow-400 text-gray-900 font-semibold py-2 px-5 rounded-md hover:bg-yellow-300 transition duration-300 shadow animate-pulse"
      >
        ⬇️ Continue to Step 2
      </button>
    )}
  </div>
</section>

        
        {/* Top Section - Financial Content */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Latest Financial News</h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {/* Card 1 */}
            <div className="bg-white border border-gray-200 rounded-lg shadow-md p-6 hover:shadow-lg transition">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                <span className="text-2xl">📊</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Stock Market Update</h3>
              <p className="text-gray-600 mb-4">
                Today's stock market shows significant gains. SENSEX rises by 500 points and NIFTY reaches new heights.
              </p>
              <a href="https://otieu.com/4/10592895" className="text-blue-600 font-semibold hover:underline">Read More →</a>
            </div>

            {/* Card 2 */}
            <div className="bg-white border border-gray-200 rounded-lg shadow-md p-6 hover:shadow-lg transition">
              <div className="bg-green-100 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                <span className="text-2xl">💰</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Investment Tips</h3>
              <p className="text-gray-600 mb-4">
                5 most important investment tips for new investors that can save your money and provide good returns.
              </p>
              <a href="/" className="text-blue-600 font-semibold hover:underline">Read More →</a>
            </div>

            {/* Card 3 */}
            <div className="bg-white border border-gray-200 rounded-lg shadow-md p-6 hover:shadow-lg transition">
              <div className="bg-purple-100 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                <span className="text-2xl">📈</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Mutual Funds Guide</h3>
              <p className="text-gray-600 mb-4">
                Complete guide to investing in mutual funds. Get all information from SIP to lumpsum here.
              </p>
              <a href="/" className="text-blue-600 font-semibold hover:underline">Read More →</a>
            </div>
          </div>
        </section>

        {/* Crypto Section */}
        <section className="mb-12 bg-gradient-to-r from-purple-50 to-blue-50 rounded-xl p-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Cryptocurrency Market</h2>
          
          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                  <div className="bg-orange-100 w-10 h-10 rounded-full flex items-center justify-center mr-3">
                    <span className="text-xl">₿</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">Bitcoin</h3>
                    <p className="text-sm text-gray-500">BTC</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xl font-bold text-gray-800">$45,230</p>
                  <p className="text-sm text-green-600">+5.2%</p>
                </div>
              </div>
              <p className="text-gray-600 text-sm">
                Bitcoin is in a strong position today and could be a good opportunity for new investors.
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                  <div className="bg-blue-100 w-10 h-10 rounded-full flex items-center justify-center mr-3">
                    <span className="text-xl">Ξ</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">Ethereum</h3>
                    <p className="text-sm text-gray-500">ETH</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xl font-bold text-gray-800">$2,890</p>
                  <p className="text-sm text-green-600">+3.8%</p>
                </div>
              </div>
              <p className="text-gray-600 text-sm">
                Ethereum is playing a leading role in smart contracts and DeFi.
              </p>
            </div>
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
            <p className="text-sm text-gray-700">
              <span className="font-semibold">⚠️ Disclaimer:</span> Cryptocurrency investment involves risk. Invest only after complete research.
            </p>
          </div>
        </section>

        {/* Stock Market Analysis */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Stock Market Analysis</h2>
          
          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md mb-6">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Top Performing Stocks</h3>
            
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Company</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Price</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Change</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Volume</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-800">Reliance Industries</td>
                    <td className="px-4 py-3 text-sm text-gray-800">₹2,456</td>
                    <td className="px-4 py-3 text-sm text-green-600">+2.5%</td>
                    <td className="px-4 py-3 text-sm text-gray-600">12.5M</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-800">TCS</td>
                    <td className="px-4 py-3 text-sm text-gray-800">₹3,789</td>
                    <td className="px-4 py-3 text-sm text-green-600">+1.8%</td>
                    <td className="px-4 py-3 text-sm text-gray-600">8.2M</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-800">HDFC Bank</td>
                    <td className="px-4 py-3 text-sm text-gray-800">₹1,623</td>
                    <td className="px-4 py-3 text-sm text-red-600">-0.5%</td>
                    <td className="px-4 py-3 text-sm text-gray-600">15.7M</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-800">Infosys</td>
                    <td className="px-4 py-3 text-sm text-gray-800">₹1,456</td>
                    <td className="px-4 py-3 text-sm text-green-600">+3.2%</td>
                    <td className="px-4 py-3 text-sm text-gray-600">10.3M</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-green-50 rounded-lg p-6 border border-green-200">
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Bulls Active</h4>
              <p className="text-3xl font-bold text-green-600 mb-2">68%</p>
              <p className="text-sm text-gray-600">Positive sentiment in the market</p>
            </div>

            <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Trading Volume</h4>
              <p className="text-3xl font-bold text-blue-600 mb-2">₹45,600 Cr</p>
              <p className="text-sm text-gray-600">Today's total turnover</p>
            </div>

            <div className="bg-purple-50 rounded-lg p-6 border border-purple-200">
              <h4 className="text-lg font-semibold text-gray-800 mb-2">FII Activity</h4>
              <p className="text-3xl font-bold text-purple-600 mb-2">+₹2,340 Cr</p>
              <p className="text-sm text-gray-600">Net buying today</p>
            </div>
          </div>
        </section>

        {/* Additional Financial Content */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Financial Planning Tips</h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">💼 Retirement Planning</h3>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>Save at least 20% of your monthly income</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>Make long-term investments in PPF and NPS</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>Get health insurance and life insurance</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>Build an emergency fund worth 6 months of expenses</span>
                </li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">📊 Smart Investment Strategy</h3>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  <span>Diversification is the key to success</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  <span>Set both short-term and long-term goals</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  <span>Time in market is more important than market timing</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  <span>Review and rebalance your portfolio regularly</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Tax Saving Section */}
        <section className="mb-12 bg-gray-50 rounded-xl p-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">💸 Tax Saving Options</h2>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg p-5 shadow">
              <h4 className="font-semibold text-gray-800 mb-2">Section 80C</h4>
              <p className="text-2xl font-bold text-blue-600 mb-2">₹1.5 Lakh</p>
              <p className="text-sm text-gray-600">PPF, ELSS, Life Insurance premium</p>
            </div>

            <div className="bg-white rounded-lg p-5 shadow">
              <h4 className="font-semibold text-gray-800 mb-2">Section 80D</h4>
              <p className="text-2xl font-bold text-green-600 mb-2">₹25,000</p>
              <p className="text-sm text-gray-600">Health Insurance premium</p>
            </div>

            <div className="bg-white rounded-lg p-5 shadow">
              <h4 className="font-semibold text-gray-800 mb-2">HRA Exemption</h4>
              <p className="text-2xl font-bold text-purple-600 mb-2">Varies</p>
              <p className="text-sm text-gray-600">House Rent Allowance</p>
            </div>
          </div>
        </section>

        {/* More Content for Scrolling */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">📚 Financial Education</h2>
          
          <div className="space-y-6">
            <div className="bg-white border-l-4 border-blue-500 p-6 rounded-lg shadow">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">What is Compounding?</h3>
              <p className="text-gray-600 mb-3">
                Compounding is "interest on interest". When your investment returns also generate returns, 
                your money grows exponentially. This is the most powerful tool for long-term wealth creation.
              </p>
              <p className="text-gray-600">
                Example: If you invest ₹10,000 with 10% annual return, it will become ₹1,74,494 after 30 years!
              </p>
            </div>

            <div className="bg-white border-l-4 border-green-500 p-6 rounded-lg shadow">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">Understanding Risk vs Return</h3>
              <p className="text-gray-600 mb-3">
                To get higher returns, you need to take higher risks. But you should invest only after considering 
                your risk tolerance and investment horizon.
              </p>
              <p className="text-gray-600">
                Equity has volatility in the short-term, but gives good returns in the long-term.
              </p>
            </div>

            <div className="bg-white border-l-4 border-purple-500 p-6 rounded-lg shadow">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">Power of SIP</h3>
              <p className="text-gray-600 mb-3">
                Systematic Investment Plan (SIP) is an easy way to invest a fixed amount monthly in mutual funds. 
                You can start with as little as ₹500.
              </p>
              <p className="text-gray-600">
                SIP benefits: Rupee cost averaging, disciplined investing, and the advantage of compounding.
              </p>
            </div>
          </div>
        </section>

        {/* STEP 2 - Bottom Section */}
        <section id="bottom-section" className="mb-6 bg-gradient-to-r from-green-500 to-teal-600 rounded-lg p-4 text-white shadow-md">
  <div className="max-w-md mx-auto text-center">
    <h2 className="text-xl font-semibold mb-2">🎯 Almost There!</h2>
    <p className="mb-3 text-sm text-green-100">
      Just one final step remaining to get your exclusive link
    </p>

    {step >= 2 && (
      <div className="bg-white/20 backdrop-blur-sm rounded-md p-3 mb-3">
        <div className="inline-block bg-yellow-400 text-gray-900 px-3 py-1 rounded-full mb-2 text-sm font-medium">
          ✓ Step 2/4 Complete
        </div>
      </div>
    )}

    {step === 2 && !showButton && (
      <div className="bg-white/20 backdrop-blur-sm rounded-md p-3">
        <div className="animate-spin h-8 w-8 border-4 border-white border-t-transparent rounded-full mx-auto mb-2"></div>
        <p className="text-green-100 text-sm">Loading...</p>
      </div>
    )}

    {step === 2 && showButton && (
      <button
        onClick={handleSecondButton}
        className="bg-white text-green-600 font-semibold py-2 px-4 rounded-md hover:bg-gray-100 transition duration-300 shadow"
      >
        ✨ Proceed
      </button>
    )}

    {step === 3 && timer !== null && timer > 0 && (
      <div className="bg-white/20 backdrop-blur-sm rounded-md p-3">
        <div className="text-3xl font-bold mb-1">{timer}</div>
        <p className="text-green-100 text-sm">Please wait...</p>
      </div>
    )}

    {step === 3 && showButton && (
      <button
        onClick={handleGetLink}
        className="bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900 font-semibold py-2 px-4 rounded-md hover:from-yellow-500 hover:to-orange-600 transition duration-300 shadow"
      >
        🎉 Get Link
      </button>
    )}
  </div>
</section>


        {/* Testimonials */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">💬 What Our Users Say</h2>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md">
              <div className="flex items-center mb-4">
                <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mr-3">
                  <span className="text-xl">👤</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">Rahul Patel</h4>
                  <div className="text-yellow-400">★★★★★</div>
                </div>
              </div>
              <p className="text-gray-600 italic">
                "This platform has helped me a lot in learning financial planning. Now I can invest with confidence!"
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md">
              <div className="flex items-center mb-4">
                <div className="bg-green-100 w-12 h-12 rounded-full flex items-center justify-center mr-3">
                  <span className="text-xl">👤</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">Priya Shah</h4>
                  <div className="text-yellow-400">★★★★★</div>
                </div>
              </div>
              <p className="text-gray-600 italic">
                "Explained in simple language. Got good knowledge about both crypto and stocks."
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md">
              <div className="flex items-center mb-4">
                <div className="bg-purple-100 w-12 h-12 rounded-full flex items-center justify-center mr-3">
                  <span className="text-xl">👤</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">Amit Desai</h4>
                  <div className="text-yellow-400">★★★★★</div>
                </div>
              </div>
              <p className="text-gray-600 italic">
                "Tax saving tips were very useful. I saved ₹50,000 this year!"
              </p>
            </div>
          </div>
        </section>

      </div>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8 mt-12">
        <div className="container mx-auto px-4 text-center">
          <p className="mb-2">© 2026 Financial Hub. All rights reserved.</p>
          <p className="text-gray-400 text-sm">
            Investment involves risk. Please consult an expert before investing.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;